import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import client from '../api/client';

export const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setMessage('No verification token provided.');
        return;
      }

      try {
        await client.get('/auth/verify-email', {
          params: { token },
        });
        setStatus('success');
        setMessage('Your email has been verified. An administrator will review your application and notify you by email.');
      } catch (err: any) {
        setStatus('error');
        const errorMsg = err.response?.data?.error || 'Failed to verify email. The link may have expired.';
        // Add helpful message for expired links
        if (errorMsg.includes('expired')) {
          setMessage(`${errorMsg}. Please contact admin@rdf.global to request a new verification link.`);
        } else {
          setMessage(errorMsg);
        }
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        {status === 'loading' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16, color: 'var(--c-primary)' }}>◌</div>
            <h2 className="auth-title">Verifying Email</h2>
            <p className="auth-subtitle">Please wait while we verify your email address...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16, color: 'var(--c-primary)' }}>✓</div>
            <h2 className="auth-title">Email Verified</h2>
            <p className="auth-subtitle">{message}</p>
            <button className="btn btn-primary btn-full" onClick={() => navigate('/login')}>
              Continue to Log In
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16, color: 'var(--c-error)' }}>✗</div>
            <h2 className="auth-title">Verification Failed</h2>
            <p className="auth-subtitle" style={{ marginBottom: 24 }}>{message}</p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button className="btn btn-primary" onClick={() => navigate('/')}>
                Home
              </button>
              <button className="btn btn-outline" onClick={() => navigate('/register')}>
                Register Again
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
